import { Col, Container, Row } from "react-bootstrap";

interface NotFoundInterface {
    text?: string;
}

export const NotFound = (props: NotFoundInterface) => {

    return (
        <>
            <Container fluid style={{ position: 'fixed', top: '240px', zIndex: 998, paddingTop: '4px' }}>
                <Row className="mt-2 mb-2">
                    <Col md={1}></Col>
                    <Col md={10}>
                        <div className="text-muted mt-5 text-center">
                            <div>
                                <img
                                    src="/hero-otter-hiding.png"
                                    style={{ objectFit: 'contain', width: '100%', height: '120px' }}
                                />
                            </div>
                            <div className="mt-4">
                                <strong>{props.text ?? 'Page Not Found'}</strong>
                            </div>
                            <div className="mt-2">
                                Let's get back on track - search for a patient above.
                            </div>
                        </div>
                    </Col>
                    <Col md={1}></Col>
                </Row>
            </Container>
        </>
    );
};
